import { render, staticRenderFns } from "./AlterationReports.vue?vue&type=template&id=c3250018&scoped=true&"
import script from "./AlterationReports.vue?vue&type=script&lang=js&"
export * from "./AlterationReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3250018",
  null
  
)

export default component.exports